module.exports = __webpack_public_path__ + "i18n/es_c4a3380f39b03ebf4fe566051b57fdff.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/es.json
// module id = +lAx
// module chunks = 154